import { injectable } from 'inversify'

/**
 * Wraps browser sessionStorage (invariant 8: all browser APIs behind a gateway).
 * Session-scoped on purpose: survives reload, dies with the tab.
 *
 * Same contract as LocalStorageGateway — values in, values out, JSON handled
 * here because it is the medium's wire format. See that file for the reasoning,
 * and for the caveat that a parseable value is still an unvalidated one.
 */
@injectable()
export class SessionStorageGateway {
  getValue(key: string): unknown | null {
    const raw = window.sessionStorage.getItem(key)
    if (raw === null) return null

    try {
      return JSON.parse(raw) as unknown
    } catch {
      window.sessionStorage.removeItem(key)
      return null
    }
  }

  setValue<T>(key: string, value: T): void {
    window.sessionStorage.setItem(key, JSON.stringify(value))
  }

  remove(key: string): void {
    window.sessionStorage.removeItem(key)
  }
}
